import onUserHasConsentedToCookies from "../../../../CodeQ.Site/Resources/Private/Fusion/onUserHasConsentedToCookies";

export default class GoogleRecaptcha {
	static init() {
        onUserHasConsentedToCookies('statistics', () => {
			Array.prototype.forEach.call(document.querySelectorAll('.google-recaptcha.google-recaptcha--not-invoked'), el => {
				new GoogleRecaptcha(el);
			});
		}, true);
	}
    constructor(element) {
        if (!element) return;
        element.setAttribute('src', element.dataset.src)
        delete element.dataset.src
    }
}
